/** @jsxImportSource @emotion/react */

import ChatbotTranslatorStructure from "src/components/ChatbotTranslatorStructure";

export default function ChatbotTranslationLocale() {
  return <ChatbotTranslatorStructure />;
}
